import e from './explore.module.css';

const Explore = () => {

    return (
        <div>
            Explore          
        </div>
    );
}

export default Explore;